export default {
  countCells: 12,
  massive: [
    {
      dataField: 'actions',
      cols: 1,
      rows: 2,
      text: '',
      class: 'd-flex flex-row align-center justify-center ',
      order: 0,
      variable: true,
    },
    {
      dataField: 'npg',
      cols: 3,
      rows: 2,
      headerClass: 'd-flex flex-row justify-start pa-0 font-size-small__important',
      class: 'justify-start d-flex flex-row',
      text: 'Код и наименование УГСН (НПС), группы научных специальностей',
      html: 'Код и наименование<br> УГСН (НПС), группы научных специальностей',
      order: 6,
      variable: true,
    },
    {
      dataField: 'flLicense',
      cols: 1,
      rows: 2,
      headerClass: 'pa-0 font-size-small__important',
      class: 'd-flex flex-row align-center justify-center ',
      styles: 'justify-content: unset; text-align: center; text-align: center;',
      text: 'Наличие лицензии',
      order: 6,
      variable: true,
    },
    {
      dataField: 'flAccred',
      cols: 1,
      rows: 2,
      text: `Наличие гос. аккредитации`,
      order: 7,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      class: 'd-flex flex-row align-center justify-center ',
      styles: 'justify-content: unset; text-align: center; text-align: center;',
    },
    {
      dataField: 'npg11',
      cols: 3,
      rows: 1,
      headerClass: 'text-center border-bottom-zero',
      text: 'минимальные значения на 2024/2025 учебный год',
      order: 1,
      variable: false,
    },
    {
      dataField: 'npg16',
      cols: 3,
      rows: 1,
      headerClass: 'text-center border-bottom-zero',
      text: 'максимальные значения на 2024/2025 учебный год',
      order: 1,
      variable: false,
    },
    {
      dataField: 'qMinO',
      cols: 1,
      rows: 1,
      text: `очно`,
      order: 8,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qMinV',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      order: 9,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qMinZ',
      cols: 1,
      rows: 1,
      text: `заочно`,
      order: 10,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qMaxO',
      cols: 1,
      rows: 1,
      text: `очно`,
      order: 8,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qMaxV',
      cols: 1,
      rows: 1,
      text: `очно-заочно`,
      order: 9,
      variable: true,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      styles: 'justify-content: unset; text-align: center;',
    },
    {
      dataField: 'qMaxZ',
      cols: 1,
      rows: 1,
      text: `заочно`,
      order: 10,
      headerClass: 'pa-0 font-size-small__important',
      rules: [
        v => !!v || 'введите значение',
      ],
      variable: true,
      styles: 'justify-content: unset; text-align: center;',
    },
  ]
}

export const headersForDialog = [
  {
    "additionalText": `УГСН (НПС), группа научных специальностей`,
    "text": "",
    "dataField": "kcpGroupId",
    "typeVar": "selector",
    "variableName": 'kcpGroupId',
    "sprDataName": 'kcpGroup',
    'initUpdate': true,
    "order": 0,
  },
  {
    "additionalText": `Минимальные значения КЦП на 2024/25 учебный год`,
    "text": "очно",
    "dataField": "qMinO",
    "typeVar": "integer",
    "fieldBlock": "o",
    "foId": 1,
    type: 'number',
    cols: 4,
    "order": 1,
  }, {

    "text": "очно-заочно",
    "dataField": "qMinV",
    "typeVar": "integer",
    "fieldBlock": "v",
    "foId": 2,
    type: 'number',
    cols: 4,
    "order": 1,
  }, {

    "text": "заочно",
    "dataField": "qMinZ",
    "typeVar": "integer",
    "fieldBlock": "z",
    "foId": 3,
    "isPadding": false,
    type: 'number',
    cols: 4,
    "order": 1,
  },
  {
    "additionalText": `Максимальные значения КЦП на 2024/25 учебный год`,
    "text": "очно",
    "dataField": "qMaxO",
    "typeVar": "integer",
    "fieldBlock": "o",
    "foId": 1,
    type: 'number',
    cols: 4,
    "order": 1,
  }, {

    "text": "очно-заочно",
    "dataField": "qMaxV",
    "typeVar": "integer",
    "fieldBlock": "v",
    "foId": 2,
    type: 'number',
    cols: 4,
    "order": 1,
  }, {

    "text": "заочно",
    "dataField": "qMaxZ",
    "typeVar": "integer",
    "fieldBlock": "z",
    "foId": 3,
    type: 'number',
    cols: 4,
    "order": 1,
  },
]